module.exports = require("@material-ui/icons/Help");